import React, { memo, useEffect, useMemo } from "react"
import { DropdownToggle } from "reactstrap"
import PropTypes from "prop-types"
import { Dropdown, DropdownItem } from "components/common/Dropdown"
import Icon from "components/common/Icon"
import DatepickerInput from "components/form/DatepickerInput"

import moment from "moment"

import { DATE_FORMAT } from "modules/datepicker/constants"

const RANGES = {
  current_month: "Current month",
  last_month: "Last month",
  last_30_days: "Last 30 days",
  total_by_scope: "Custom date range"
}

RangeSelector.propTypes = {
  params: PropTypes.shape({
    type: PropTypes.string,
    overview_range: PropTypes.string,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired,
  onChangeFilters: PropTypes.func.isRequired
}
function RangeSelector({ params, onChangeFilters }) {
  const gteqMaxDate = useMemo(() => (params.date_lteq ? global.dateTime(params.date_lteq).endOf("date") : false), [params.date_lteq])
  const lteqMinDate = useMemo(() => (params.date_gteq ? global.dateTime(params.date_gteq).startOf("date") : false), [params.date_gteq])
  const lteqMaxDate = global.dateTime().endOf("date")

  useEffect(() => {
    if (params.type !== "business_overview") {
      onChangeFilters({ target: { name: "overview_range", value: null } })
      onChangeFilters({ target: { name: "date_gteq", value: null } })
      onChangeFilters({ target: { name: "date_gteq", value: null } })
      return
    }
    if (!params.overview_range) onChangeFilters({ target: { name: "overview_range", value: "current_month" } })
  }, [params.type]) //eslint-disable-line

  useEffect(() => {
    if (!params.overview_range || params.overview_range !== "total_by_scope") {
      onChangeFilters({ target: { name: "date_gteq", value: null } })
      onChangeFilters({ target: { name: "date_lteq", value: null } })
      return
    }

    const defaultStartDate = moment(params.date_lteq ? params.date_lteq : moment())
      .startOf("month")
      .format(DATE_FORMAT)
    const defaultEndDate = moment().format(DATE_FORMAT)

    if (!params.date_gteq) onChangeFilters({ target: { name: "date_gteq", value: defaultStartDate } })
    if (!params.date_lteq) onChangeFilters({ target: { name: "date_lteq", value: defaultEndDate } })
  }, [params.overview_range]) //eslint-disable-line

  return (
    <div className="d-flex gap-20 align-items-center flex-wrap">
      <Dropdown
        className="my-n1"
        toggleButton={
          <DropdownToggle color="ghost" className="hstack gap-2 rounded-1 m-0 p-1">
            <h1 className="h3 fw-medium lh-1">{RANGES[params.overview_range]}</h1>
            <Icon iconName="SidebarToggle" size={20} />
          </DropdownToggle>
        }
      >
        {Object.entries(RANGES).map(([range, label]) => (
          <DropdownItem key={range} name="overview_range" value={range} onClick={onChangeFilters}>
            {label}
          </DropdownItem>
        ))}
      </Dropdown>
      {params.overview_range === "total_by_scope" && (
        <div className="d-flex gap-x-10 gap-y-1 align-items-center flex-wrap flex-fill">
          <DatepickerInput
            name="date_gteq"
            value={params.date_gteq}
            onChange={onChangeFilters}
            restrictions={{
              ...((gteqMaxDate || lteqMaxDate) && { maxDate: gteqMaxDate || lteqMaxDate })
            }}
            className="flex-grow-1 flex-sm-grow-0"
            inputClassName="fs-6 fw-medium"
            inputGroupClassName="w-sm-auto"
          />
          {" - "}
          <DatepickerInput
            name="date_lteq"
            value={params.date_lteq}
            onChange={onChangeFilters}
            restrictions={{
              ...(lteqMinDate && { minDate: lteqMinDate }),
              ...(lteqMaxDate && { maxDate: lteqMaxDate })
            }}
            className="flex-grow-1 flex-sm-grow-0"
            inputClassName="fs-6 fw-medium"
            inputGroupClassName="w-sm-auto"
          />
        </div>
      )}
    </div>
  )
}

export default memo(RangeSelector)
